var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.mobileView
      ? _c("div", { staticClass: "login", attrs: { id: "bloque1" } }, [
          _c("div", { staticClass: "loginBox" }, [
            _c("img", {
              staticClass: "loginBoxImg",
              attrs: { src: "/dist/logo-login.png" }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "labels",
                staticStyle: {
                  "font-weight": "400",
                  "font-size": "20px",
                  "margin-bottom": "0px"
                },
                attrs: { id: "titulo" }
              },
              [_vm._v("Registro")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "labels", attrs: { id: "info" } }, [
              _vm._v(
                "Si quiere ingresar al sistema necesitamos darlo de alta, por favor complete los siguientes datos y nos pondremos en contacto para darle acceso"
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("div", { staticClass: "container1" }, [
                  _c("div", { staticClass: "container2" }, [
                    _c("p", { staticClass: "labels" }, [_vm._v("NOMBRE")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nombre,
                          expression: "nombre"
                        }
                      ],
                      staticClass: "inputBoxS",
                      class: { inputBoxSInv: _vm.errorNombre },
                      attrs: { type: "text" },
                      domProps: { value: _vm.nombre },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nombre = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "container2",
                      staticStyle: { "margin-left": "20px" }
                    },
                    [
                      _c("p", { staticClass: "labels" }, [_vm._v("APELLIDO")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.apellido,
                            expression: "apellido"
                          }
                        ],
                        staticClass: "inputBoxS",
                        class: { inputBoxSInv: _vm.errorApellido },
                        attrs: { type: "text" },
                        domProps: { value: _vm.apellido },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.apellido = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "labels" }, [
                  _vm._v("NOMBRE DEL COMERCIO")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nombreComercio,
                      expression: "nombreComercio"
                    }
                  ],
                  staticClass: "inputBoxL",
                  class: { inputBoxLInv: _vm.errorNombreComercio },
                  attrs: { type: "text" },
                  domProps: { value: _vm.nombreComercio },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nombreComercio = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "labels" }, [_vm._v("DIRECCIÓN")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.direccion,
                      expression: "direccion"
                    }
                  ],
                  staticClass: "inputBoxL",
                  class: { inputBoxLInv: _vm.errorDireccion },
                  attrs: { type: "text" },
                  domProps: { value: _vm.direccion },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.direccion = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "container1" }, [
                  _c("div", { staticClass: "container2" }, [
                    _c("p", { staticClass: "labels" }, [_vm._v("EMAIL")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "inputBoxS",
                      class: { inputBoxSInv: _vm.errorEmail },
                      attrs: { type: "email" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "container2",
                      staticStyle: { "margin-left": "20px" }
                    },
                    [
                      _c("p", { staticClass: "labels" }, [_vm._v("TELÉFONO")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.telefono,
                            expression: "telefono"
                          }
                        ],
                        staticClass: "inputBoxS",
                        class: { inputBoxSInv: _vm.errorTelefono },
                        attrs: { type: "text" },
                        domProps: { value: _vm.telefono },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.telefono = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "btnContainer" } }, [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnCancelar" },
                      on: { click: _vm.btnCancelar }
                    },
                    [_vm._v("CANCELAR")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "btnEnviar" },
                      on: { click: _vm.btnEnviar }
                    },
                    [_vm._v("ENVIAR")]
                  )
                ])
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.mobileView
      ? _c(
          "div",
          {
            staticClass: "fv ct",
            staticStyle: { width: "100vw", height: "100vh" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv cc",
                staticStyle: {
                  width: "100%",
                  height: "4%",
                  background: "#44C7F4",
                  color: "#ffffff"
                }
              },
              [_vm._v("Registro")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv cc",
                staticStyle: {
                  width: "90%",
                  height: "15%",
                  "font-size": "10px"
                }
              },
              [
                _vm._v(
                  "Si quiere ingresar al sistema necesitamos darlo de alta, por favor complete los siguientes datos y nos pondremos en contacto para darle acceso"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "fh cc", staticStyle: { width: "90%" } }, [
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { width: "50%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fv lc",
                      staticStyle: { "font-size": "9px" }
                    },
                    [_vm._v("NOMBRE")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nombre,
                        expression: "nombre"
                      }
                    ],
                    staticClass: "inputBoxS",
                    class: { inputBoxSInv: _vm.errorNombre },
                    staticStyle: { width: "90%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.nombre },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nombre = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { width: "50%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fv lc",
                      staticStyle: { "font-size": "9px" }
                    },
                    [_vm._v("APELLIDO")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.apellido,
                        expression: "apellido"
                      }
                    ],
                    staticClass: "inputBoxS",
                    class: { inputBoxSInv: _vm.errorApellido },
                    staticStyle: { width: "90%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.apellido },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.apellido = $event.target.value
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fv lc", staticStyle: { width: "90%" } }, [
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { "font-size": "9px" } },
                [_vm._v("NOMBRE DEL COMERCIO")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nombreComercio,
                    expression: "nombreComercio"
                  }
                ],
                staticClass: "inputBoxL",
                class: { inputBoxLInv: _vm.errorNombreComercio },
                staticStyle: { width: "95%" },
                attrs: { type: "text" },
                domProps: { value: _vm.nombreComercio },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nombreComercio = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fv lc", staticStyle: { width: "90%" } }, [
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { "font-size": "9px" } },
                [_vm._v("DIRECCIÓN")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.direccion,
                    expression: "direccion"
                  }
                ],
                staticClass: "inputBoxL",
                class: { inputBoxLInv: _vm.errorDireccion },
                staticStyle: { width: "95%" },
                attrs: { type: "text" },
                domProps: { value: _vm.direccion },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.direccion = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fh cc", staticStyle: { width: "90%" } }, [
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { width: "50%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fv lc",
                      staticStyle: { "font-size": "9px" }
                    },
                    [_vm._v("EMAIL")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "inputBoxS",
                    class: { inputBoxSInv: _vm.errorEmail },
                    staticStyle: { width: "90%" },
                    attrs: { type: "email" },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { width: "50%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fv lc",
                      staticStyle: { "font-size": "9px" }
                    },
                    [_vm._v("TELÉFONO")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.telefono,
                        expression: "telefono"
                      }
                    ],
                    staticClass: "inputBoxS",
                    class: { inputBoxSInv: _vm.errorTelefono },
                    staticStyle: { width: "90%" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.telefono },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.telefono = $event.target.value
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh cc",
                staticStyle: { width: "90%", "margin-top": "40px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cc btnEmpty1",
                    staticStyle: { "font-size": "9px", height: "30px" },
                    on: { click: _vm.btnCancelar }
                  },
                  [_vm._v("CANCELAR")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc btnFull1",
                    staticStyle: {
                      "font-size": "9px",
                      background: "#005A9F",
                      "border-color": "#005A9F",
                      height: "30px"
                    },
                    on: { click: _vm.btnEnviar }
                  },
                  [_vm._v("ENVIAR")]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fv cc",
        staticStyle: { width: "100%", height: "6%", background: "#005A9F" }
      },
      [
        _c("img", {
          staticStyle: { height: "18px" },
          attrs: { src: "/dist/logo_header2.png" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66070664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66070664","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/registro.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66070664","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/registro.vue
// module chunks = 0